(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo/assets/javascripts/marionette/reqres.js') >= 0) return;  svs.modules.push('/modules/bingo/assets/javascripts/marionette/reqres.js');
function isDST(date) {
  var jan = new Date(date.getFullYear(), 0, 1);
  var jul = new Date(date.getFullYear(), 6, 1);
  return date.getTimezoneOffset() < Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
}

(function (Backbone, _, svs) {

  'use strict';

  svs.bingo.nyxChannel.reply('gameById', function (gameId) {
    var deferred = $.Deferred();

    svs.bingo.nyxChannel.request('activeGames').then(function (res) {
      var i = res.games.length;

      while (i--) {
        if (+res.games[i].id === gameId) {
          deferred.resolve(res.games[i]);
          break;
        }
      }
    });

    return deferred.promise();
  });

  svs.bingo.nyxChannel.reply('startpageOptions', function () {
    var startPageConfig = svs.bingo.data.bingoconfig.startPageConfig,
      deferred = $.Deferred();

    svs.bingo.nyxChannel.request('activeGames').then(function (res) {
      var matches = [],
        currGame,
        promo = startPageConfig.promo,
        activeGames = res.games,
        lastWins = res.lastwin,
        dur,
        i,
        j,
        k,
        l,
        opensToday;

      i = activeGames.length;
      while (i--) {
        currGame = activeGames[i];
        if (+currGame.sts > 7200) {
          continue;
        }
        j = promo.length;
        while (j--) {
          if (+currGame.id === +promo[j].id) {
            opensToday = false;
            currGame.backgroundImageLarge = promo[j].backgroundImage;
            currGame.lastWinTS = '';
            currGame.disabled = true;

            var dayNr,
              schemaArray = currGame.schema.match(/\d*-\d*\/[a-zåäö]+/gi),
              day,
              time,
              timeOpen,
              timeClose,
              date = new Date(res.time.replace(' ', 'T')), 
              diffHours = isDST(date) ? 2 : 1,
              currentMinute,
              tempdate,
              tempString;

            for (l = 0; l < schemaArray.length; l++) {
              time = schemaArray[l].split('/')[0];
              day = schemaArray[l].split('/')[1];

              switch (day.toLowerCase()) {
                case 'måndag':
                  dayNr = 1;
                  break;
                case 'tisdag':
                  dayNr = 2;
                  break;
                case 'onsdag':
                  dayNr = 3;
                  break;
                case 'torsdag':
                  dayNr = 4;
                  break;
                case 'fredag':
                  dayNr = 5;
                  break;
                case 'lördag':
                  dayNr = 6;
                  break;
                case 'söndag':
                  dayNr = 0;
                  break;
                default:
              }

              if (dayNr === date.getDay()) {
                timeOpen = parseInt(time.split('-')[0]);
                timeClose = parseInt(time.split('-')[1]);
                currentMinute = ((dateFns.getHours(date) * 60) + dateFns.getMinutes(date));
                if (currentMinute >= timeOpen && currentMinute <= timeClose) {
                  currGame.disabled = false;
                  break;
                } else if (currentMinute < timeOpen) {
                  opensToday = true;
                }
              }
            }

            if (currGame.disabled) {
              if (opensToday) {
                let match = currGame.schema.match(/\d.:\d./g)[0].split(':');
                let d = new Date(1970, 1, 1, parseInt(match[0]), parseInt(match[1]));
                d = dateFns.addHours(d, diffHours)
                const time = 'idag kl. ' + dateFns.format(d, 'HH:mm')
                currGame.date =
                  'Öppnar ' + time.trim();
              } else {
                currGame.date = currGame.schema.match(/[a-zåäö]+ \d.:\d./gi)[1];
                let time = currGame.date.split(' ')[1].split(':');
                tempdate = new Date().setHours(parseInt(time[0]), parseInt(time[1]))
                tempdate = dateFns.addHours(tempdate, diffHours)
                tempString = dateFns.formatRelative(tempdate, new Date(), { locale: dateFns.locales.sv })
                tempString = (
                  tempString.substr(0, 1).toUpperCase() + tempString.substr(1)
                );
                currGame.date =
                  'Öppnar ' + tempString
              }
            } else {
              dur = dateFns.addSeconds(new Date(0), +currGame.sts);
              if (currGame.playmode === 'SINGLEUSER') {
                currGame.secondsLeft = 0;
                currGame.date = undefined;
              } else {
                currGame.secondsLeft = +currGame.sts;
                currGame.date = dateFns.format(dur, 'mm:ss')
              }
            }
            k = lastWins.length;
            while (k--) {
              if (
                currGame.name === lastWins[k].game &&
                currGame.lastWinTS < lastWins[k].time
              ) {
                currGame.lastWinTS = lastWins[k].time;
              }
            }
            matches.push(currGame);
            break;
          }
        }
      }

      if (!matches.length) {
        svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
          branding: svs.ui.dialog.branding.SPORT,
          title: 'Tekniskt fel',
          icon: 'help-2',
          area: svs.ui.dialog.area.POPUP,
          type: svs.ui.dialog.type.ERROR,
          message: [
            {
              type: svs.ui.dialog.message.TEXT,
              text: 'Vi jobbar för fullt med att åtgärda felet. Välkommen tillbaka lite senare.'
            }
          ],
          actions: [
            {
              title: 'Okej',
              callback: function () {
                location.href = '/';
              }
            }
          ]
        }));
        return;
      }

      deferred.resolve({
        generalSettings: {
          branding: 'bingo-light'
        },
        promoRegion: {
          defaultPromo: {
            items: new svs.bingo.collections.ActiveGames(matches, {
              parse: true,
              comparator: 'pprio'
            }).sort()
          }
        },
        tabRegion: new Backbone.Model({
          items: startPageConfig.tabs,
          buttons: [
            {
              label: 'Spela'
            }
          ]
        })
      });
    });

    return deferred.promise();
  });

  svs.bingo.nyxChannel.reply('updateCollection', function (col1, col2) {
    var requiresRender = false,
      i,
      j;
    if (col1.models.length !== col2.models.length) {
      col1.reset(col2.models);
      requiresRender = true;
    } else {
      for (i = 0; i < col1.models.length; i++) {
        for (j = 0; j < col2.models.length; j++) {
          if (col1.models[i].get('id') === col2.models[j].get('id')) {
            col1.models[i].set('jackpot', col2.models[j].get('jackpot'));
            col1.models[i].set(
              'jackpotText',
              col2.models[j].get('jackpotText')
            );
            col1.models[i].set('disabled', col2.models[j].get('disabled'));
            col1.models[i].set('moneyRain', col2.models[j].get('moneyRain'));
            col1.models[i].set('lastWinTS', col2.models[j].get('lastWinTS'));
            col1.models[i].set(
              'hasChatHost',
              col2.models[j].get('hasChatHost')
            );
            col1.models[i]
              .get('infoBar')
              .set('date', col2.models[j].get('infoBar').get('date'));
            col1.models[i]
              .get('infoBar')
              .set('users', col2.models[j].get('infoBar').get('users'));
            if (col2.models[j].get('secondsLeft') >= 0) {
              col1.models[i].set(
                'secondsLeft',
                col2.models[j].get('secondsLeft')
              );
            }
            break;
          }
        }
      }
    }

    return {
      collection: col1,
      requiresRender: requiresRender
    };
  });

  svs.bingo.nyxChannel.reply('hasAlias', function () {
    var deferred = $.Deferred(),
      options = {
        method: 'GET',
        path: '/player/1/alias'
      };
    svs.core.jupiter.call(
      options,
      function (data) {
        deferred.resolve(!!data.alias);
      },
      function () {
        deferred.resolve(false);
      }
    );

    return deferred.promise();
  });
})(Backbone, _, svs);


 })(window);